import React from 'react';
import styles from './Complete.module.scss';
import global from '../../../styles/index.module.scss';
import { Layout } from '../../../components/common/Layout/Layout';

declare global {
  interface Window {
    isLoggedIn: boolean;
  }
}

export const Complete: React.FC = () => {
  return (
    <div className={styles.complete}>
      <Layout>
        <h2 className={`${styles.headingLv2} ${styles.isCenter}`}>配送修理のお申し込みが完了しました<br />「ユーザー登録」を行い<br />修理品をリペアセンターに発送してください。</h2>
        <ul className={styles.list}>
          <li className={styles.item}>会員登録は「お支払い方法や返送先の登録」のため必要となります。</li>
          <li className={styles.item}>注文から10日以内に修理品の到着が確認できない場合は、自動キャンセルとなります。再度、お見積もりをお送りください。</li>
          <li className={`${styles.item} ${styles.isBold}`}>必ず、お問い合わせ時にご利用いただいたメールアドレスで登録してください。（他のメールアドレスを登録するとエラーの原因となります）</li>
        </ul>
        <div className={styles.contentWrappper}>
          <div className={global.buttonWrapper}>
            <a href='/account/register' className={global.primaryButton}>
              ユーザー登録はこちら
            </a>
            <a href='/account/register'>初めてご利用のかたはこちら</a>
          </div>
        </div>
        <div className={styles.contentWrappper}>
          <div className={global.buttonWrapper}>
            <a href='/account/login?return_url=/account' className={global.primaryButton}>
              ログイン
            </a>
            <a href='/account/login?return_url=/account'>アカウントをお持ちの方はこちら</a>
          </div>
        </div>
      </Layout>
    </div>
  )
};